import {OCPPTagDTO, UserDTO} from '../../../types';
import {TagsDTO} from '../../../types/tags';

export type RfidTableProps = {
    data?: UserDTO | (UserDTO & { ocppTags: TagsDTO[] | OCPPTagDTO[]; employeeId?: number });
    isCompanyUser?: boolean;
    companyId?: number;
    onRefetchRfidData?: () => void;
};

export enum BlockStatusEnum {
    accepted = 'accepted',
    blocked = 'blocked',
}

export enum ValidityEnum {
    expired = 'expired',
    actual = 'actual',
}
